import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { ClientDetail } from '@/components/clients/ClientDetail';

export default function ClientDetailPage() {
  return (
    <ProtectedRoute>
      <ClientDetail />
    </ProtectedRoute>
  );
}
